module.exports = __webpack_public_path__ + "img/58.983599c6.jpg";